import './liveTrackDetails.css';
import {Link} from "react-router-dom";
import TripsList from "../../components/tripsComponent/allTrips/tripsList/tripsList";
import VideoSec from "../../components/videoSec/videoSec";
import TripFactorDetails from "../../components/tripFactorDetails/tripFactorDetails";
import TripStops from "../../components/tripStops/tripStops";
import LiveTrackDriverInfo from "../../components/liveTrackDriverInfo/liveTrackDriverInfo";
import CalendarType from "../../shared/calendarType/calendarType";
import ReactMap from "../../shared/map/map";
import DateRangePicker from "../../shared/dateRangePicker/dateRangePicker";

const LiveTrackDetails = () => {
    const driverInfo = [
        {
            text: 'KA 02  N 9023 ',
            class: 'sf-bold'
        },
        {
            text: 'Vehicle Type: HMV ',
            class: ''
        },
        {
            text: 'BharathBenz/2017 HDT R  - 30 Tons   ',
            class: ''
        },
        {
            text: <span>Avg Speed: <span className={'blue-color'}>19 Km/h</span>  </span>,
            class: ''
        },
    ];

    return (
        <div className={'content-section live-track-details-sec page-fade-in'}>
            <div className="round-corner-8 padding-tb-20 flex hr-space-between border-bottom">
                <Link to=".." relative={'path'} className="flex font-15 gap-10">
                    <div className="back-btn-circular"></div>
                    <div className="highlight-color sf-medium">Back</div>
                </Link>
                <div className="flex">
                    <DateRangePicker selectRange={true} classes={'date width-300 item-height-40'}/>
                    <CalendarType/>
                </div>
            </div>

            <div className="">
                <TripsList classes={'trip-details-list'} data={[1]}/>
            </div>

            {/*....... driver details .......*/}
            <div className="border-bottom margin-b-40"><LiveTrackDriverInfo data={driverInfo}/></div>

            {/*....... video section ......*/}
            <div className="margin-b-40">
                <div className="section-title margin-b-20">Critical Alert Videos</div>
                <VideoSec/>
            </div>

            <div className="live-track-map-sec">
                <div className="section-title margin-b-20">Map</div>
                <div className="flex align-top">
                    <div className="map-sec">
                        <ReactMap height={'600px'}/>
                    </div>
                    <div className="live-track-info-sec">
                        <div className="margin-b-30"><TripFactorDetails/></div>
                        <div className=""><TripStops/></div>
                    </div>
                </div>
            </div>

        </div>
    )
}
export default LiveTrackDetails;
